// ==========================================================================
// MT - scripts vanilla (sin librerias externas)
// ==========================================================================
document.addEventListener("DOMContentLoaded", function () {
  initReveal();
  initComparador();
  initContadores();
  initGaleriaAngulos();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
  initBarraSticky();
  initOfertaSelector();
  initOfertaColores();
  initCrosssellBundle();
  initResenasComprar();
});

function initResenasComprar() {
  document.querySelectorAll("[data-mt-resenas-comprar]").forEach(function (boton) {
    boton.addEventListener("click", function () {
      var destino = document.querySelector("[data-mt-boton-comprar]");
      if (destino) {
        destino.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        window.location.href = "/collections/all";
      }
    });
  });
}

function initOfertaSelector() {
  document.querySelectorAll("[data-mt-oferta]").forEach(function (wrap) {
    var opciones = wrap.querySelectorAll("[data-mt-oferta-opcion]");
    var cantidadWrap = document.querySelector("[data-mt-cantidad]");
    var cantidadInput = document.querySelector("[data-mt-cantidad-input]");
    var coloresWrap = document.querySelector("[data-mt-oferta-colores]");
    var filasColor = coloresWrap ? coloresWrap.querySelectorAll("[data-mt-oferta-color-fila]") : [];
    var opcionesSimples = document.querySelector("[data-mt-opciones-simple]");
    var boton = document.querySelector("[data-mt-boton-comprar]");
    if (!opciones.length || !cantidadInput) return;

    opciones.forEach(function (opcion) {
      opcion.addEventListener("click", function () {
        opciones.forEach(function (o) { o.classList.remove("mt-oferta-card-activa"); });
        opcion.classList.add("mt-oferta-card-activa");
        var cant = parseInt(opcion.getAttribute("data-mt-cantidad"), 10) || 1;
        cantidadInput.value = cant;
        if (cantidadWrap) cantidadWrap.hidden = cant !== 1;
        if (coloresWrap) coloresWrap.hidden = cant !== 2 && cant !== 3;
        filasColor.forEach(function (fila) {
          var n = parseInt(fila.getAttribute("data-mt-oferta-color-fila"), 10);
          fila.hidden = n > cant;
        });
        if (opcionesSimples) opcionesSimples.hidden = cant !== 1;
        if (boton) {
          var textoNormal = boton.getAttribute("data-mt-texto-disponible");
          var textoPorCantidad = {
            2: boton.getAttribute("data-mt-texto-pack"),
            3: boton.getAttribute("data-mt-texto-trio"),
          };
          boton.textContent = textoPorCantidad[cant] || textoNormal;
        }
      });
    });
  });
}

function initOfertaColores() {
  var form = document.querySelector("[data-mt-form-producto]");
  var ofertaWrap = document.querySelector("[data-mt-oferta]");
  var coloresWrap = document.querySelector("[data-mt-oferta-colores]");
  if (!form || !ofertaWrap || !coloresWrap) return;

  var dataEl = document.querySelector("[data-mt-variantes-json]");
  var variantes = [];
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  function variantIdParaColor(color) {
    var encontrada = variantes.find(function (v) { return v.options[0] === color; });
    return encontrada ? encontrada.id : null;
  }

  form.addEventListener("submit", function (e) {
    var opcionActiva = ofertaWrap.querySelector(".mt-oferta-card-activa");
    var cant = opcionActiva ? parseInt(opcionActiva.getAttribute("data-mt-cantidad"), 10) : 1;
    if (cant !== 2 && cant !== 3) return;

    e.preventDefault();
    var filasVisibles = coloresWrap.querySelectorAll("[data-mt-oferta-color-fila]:not([hidden])");
    var items = Array.prototype.map.call(filasVisibles, function (fila) {
      var select = fila.querySelector("[data-mt-oferta-color]");
      return { id: variantIdParaColor(select.value), quantity: 1 };
    }).filter(function (item) { return item.id; });
    if (items.length !== cant) return;

    var boton = form.querySelector("[data-mt-boton-comprar]");
    var textoOriginal = boton ? boton.textContent : "";
    if (boton) {
      boton.disabled = true;
      boton.textContent = "Añadiendo...";
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("No se pudo añadir al carrito");
        return r.json();
      })
      .then(function () {
        window.location.href = "/cart";
      })
      .catch(function () {
        if (boton) {
          boton.disabled = false;
          boton.textContent = textoOriginal;
        }
        alert("No se pudo añadir al carrito. Inténtalo de nuevo.");
      });
  });
}

function initCrosssellBundle() {
  document.querySelectorAll("[data-mt-crosssell-ambos]").forEach(function (boton) {
    boton.addEventListener("click", function () {
      var bagsId = boton.getAttribute("data-bags-variant-id");
      var sealerInput = document.querySelector('[data-mt-form-producto] input[name="id"]');
      var sealerId = sealerInput ? sealerInput.value : null;
      if (!bagsId || !sealerId) return;

      var textoOriginal = boton.textContent;
      boton.disabled = true;
      boton.textContent = "Añadiendo...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [
            { id: sealerId, quantity: 1 },
            { id: bagsId, quantity: 1 },
          ],
        }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error("No se pudo añadir al carrito");
          return r.json();
        })
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function () {
          boton.disabled = false;
          boton.textContent = textoOriginal;
          alert("No se pudo añadir el kit al carrito. Inténtalo de nuevo.");
        });
    });
  });
}

function initCantidad() {
  document.querySelectorAll("[data-mt-cantidad]").forEach(function (wrap) {
    var input = wrap.querySelector("[data-mt-cantidad-input]");
    var menos = wrap.querySelector("[data-mt-cantidad-menos]");
    var mas = wrap.querySelector("[data-mt-cantidad-mas]");
    if (!input || !menos || !mas) return;
    menos.addEventListener("click", function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
    mas.addEventListener("click", function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
    });
  });
}

function initBarraSticky() {
  var bar = document.querySelector("[data-mt-sticky-bar]");
  var boton = document.querySelector("[data-mt-boton-comprar]");
  if (!bar || !boton) return;

  var stickyBtn = bar.querySelector("[data-mt-sticky-comprar]");
  if (stickyBtn) {
    stickyBtn.addEventListener("click", function () {
      boton.click();
    });
  }

  if (!("IntersectionObserver" in window)) return;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle("mt-sticky-bar-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  obs.observe(boton);
}

function initReveal() {
  var els = document.querySelectorAll(".mt-reveal");
  if (!els.length) return;

  if (!("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    els.forEach(function (el) { el.classList.add("mt-visible"); });
    return;
  }

  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("mt-visible");
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll("[data-mt-comparador]").forEach(function (wrap) {
    var handle = wrap.querySelector("[data-mt-comparador-handle]");
    var afterEl = wrap.querySelector("[data-mt-comparador-after]");
    if (!handle || !afterEl) return;

    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
      var pct = (x / rect.width) * 100;
      afterEl.style.clipPath = "inset(0 " + (100 - pct) + "% 0 0)";
      handle.style.left = pct + "%";
    }

    handle.addEventListener("pointerdown", function (e) {
      dragging = true;
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    handle.addEventListener("pointerup", function () { dragging = false; });
    wrap.addEventListener("click", function (e) {
      if (e.target === handle) return;
      setPos(e.clientX);
    });
    handle.addEventListener("keydown", function (e) {
      var rect = wrap.getBoundingClientRect();
      var current = parseFloat(handle.style.left) || 50;
      if (e.key === "ArrowLeft") setPos(rect.left + (rect.width * Math.max(current - 5, 0)) / 100);
      if (e.key === "ArrowRight") setPos(rect.left + (rect.width * Math.min(current + 5, 100)) / 100);
    });
  });
}

function initContadores() {
  var els = document.querySelectorAll("[data-mt-contador]");
  if (!els.length) return;
  if (!("IntersectionObserver" in window)) {
    els.forEach(function (el) { el.textContent = el.getAttribute("data-mt-contador"); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var target = parseFloat(el.getAttribute("data-mt-contador")) || 0;
      var suffix = el.getAttribute("data-mt-sufijo") || "";
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
        el.textContent = current + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      obs.unobserve(el);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaAngulos() {
  document.querySelectorAll("[data-mt-angulos]").forEach(function (wrap) {
    var mainImg = wrap.querySelector("[data-mt-angulos-principal]");
    var thumbs = wrap.querySelectorAll("[data-mt-angulos-thumb]");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-mt-src");
        var srcset = thumb.getAttribute("data-mt-srcset");
        if (!src) return;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.remove("mt-thumb-activa"); });
        thumb.classList.add("mt-thumb-activa");
      });
    });
  });
}

function initGaleriaProducto() {
  document.querySelectorAll("[data-mt-producto-galeria]").forEach(function (wrap) {
    var mainImg = wrap.querySelector("[data-mt-producto-principal]");
    var thumbs = wrap.querySelectorAll("[data-mt-producto-thumb]");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-mt-full");
        if (!full) return;
        mainImg.src = full;
        thumbs.forEach(function (t) { t.classList.remove("mt-thumb-activa"); });
        thumb.classList.add("mt-thumb-activa");
      });
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector("[data-mt-form-producto]");
  if (!form) return;
  var dataEl = document.querySelector("[data-mt-variantes-json]");
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector("input[name=id]");
  var selects = form.querySelectorAll("[data-mt-opcion]");
  var precioEl = document.querySelector("[data-mt-precio]");
  var precioCompareEl = document.querySelector("[data-mt-precio-compare]");
  var botonEl = form.querySelector("[data-mt-boton-comprar]");
  var stockEl = document.querySelector("[data-mt-stock]");

  function moneda(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || "es", {
      style: "currency",
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
    });
  }

  function actualizar() {
    var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
    var encontrada = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valores[i]; });
    });
    if (!encontrada) return;

    idInput.value = encontrada.id;
    if (precioEl) precioEl.textContent = moneda(encontrada.price);
    if (precioCompareEl) {
      if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
        precioCompareEl.textContent = moneda(encontrada.compare_at_price);
        precioCompareEl.hidden = false;
      } else {
        precioCompareEl.hidden = true;
      }
    }
    if (botonEl) {
      botonEl.disabled = !encontrada.available;
      botonEl.textContent = encontrada.available
        ? botonEl.getAttribute("data-mt-texto-disponible")
        : botonEl.getAttribute("data-mt-texto-agotado");
    }
    if (stockEl) stockEl.hidden = encontrada.available;

    var featuredMediaId = encontrada.featured_media && encontrada.featured_media.id;
    if (featuredMediaId) {
      var thumb = document.querySelector('[data-mt-producto-thumb][data-mt-media-id="' + featuredMediaId + '"]');
      if (thumb) thumb.click();
    }
  }

  selects.forEach(function (s) { s.addEventListener("change", actualizar); });
}
